import { Box, Flex, Notification } from '@volue/wave-react';
import type { NotificationProps } from '@volue/wave-react/dist/ts/components/Notification';
import React from 'react';

export const InlineNotification: React.FunctionComponent<{
  content: string | JSX.Element;
  className?: string;
  type: 'WARNING' | 'INFO' | 'ERROR' | 'SUCCESS';
  actionButtons?: JSX.Element[];
}> = props => {
  const notificationType =
    props.type.toLocaleLowerCase() as unknown as NonNullable<
      NotificationProps['type']
    >;
  return (
    <Notification type={notificationType} className={props.className}>
      <Flex flow="column" cross="center">
        <Flex>
          <Box>{props.content}</Box>
        </Flex>
        {props.actionButtons && (
          <Flex flow={'column'} main="end">
            {props.actionButtons || []}
          </Flex>
        )}
      </Flex>
    </Notification>
  );
};

export const InlineInfoNotificationSmallIcon: React.FunctionComponent<{
  text: string;
}> = ({ text }) => {
  return (
    <Box>
      <div className="notification notification--info" role="status">
        <div className="svgIcon svgIcon--stroked">
          <svg focusable="false" aria-hidden="true">
            <use xlinkHref="#svg--info" color="#157084" />
          </svg>
        </div>
        <div className="notification-message mLl">
          <span>{text}</span>
        </div>
      </div>
    </Box>
  );
};
